export default "__VITE_ASSET__9aee883a__"